import NationalBodiesPage from "./pages/NationalBodiesPage";

/** Gated on the privilege — see the note in chapter/routes.tsx. */
export const nationalBodyRoutes = [
  {
    path: "/admin/national-bodies",
    element: <NationalBodiesPage />,
    perms: ["national_body.access"],
  },
];
